//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'Control',
  components: {
  },
  data: function() {
    return {
      patterns: [],
      playlists: [],
      solidcolor: '',
      speed: 7,
      lightingMode: null
    }
  },
  methods: {
    stop: function() {
      axios.get(this.$root.baseURL + "/exec/stop");
      this.$toasted.success('Robot halted', {
        duration: 750
      })
    },
    componentToHex: function(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex: function(r, g, b) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    hexToRgb: function(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    home: function() {
      axios.get(this.$root.baseURL + "/exec/G28");
      this.$toasted.success('Homing in progress', {
        duration: 750
      })
    },
    reset: function() {
      axios.get(this.$root.baseURL + "/reset");
      this.$toasted.success('Robot reset, please exit and reopen app', {
        duration: 750
      })
    }
  },
  mounted: function() {
    this.speed = this.$root.status.rpm;
    this.lightingMode = this.$root.wledStatus.effects[this.$root.wledStatus.state.seg[0].fx];
    this.solidcolor = this.rgbToHex(this.$root.wledStatus.state.seg[0].col[0][0], this.$root.wledStatus.state.seg[0].col[0][1], this.$root.wledStatus.state.seg[0].col[0][2]);
  },
  watch: {
    solidcolor: function(val) {
      const newR = this.hexToRgb(val).r;
      const newG = this.hexToRgb(val).g;
      const newB = this.hexToRgb(val).b;

      if(newR != this.$root.wledStatus.state.seg[0].col[0][0] || newG != this.$root.wledStatus.state.seg[0].col[0][1] || newB != this.$root.wledStatus.state.seg[0].col[0][2]) {
        axios.post(this.$root.wledURL + "/json/state", {seg: [{ col: [
            [newR, newG, newB]
          ]
        }]});
      }
    },
    lightingMode: function(val) {
      if(this.$root.wledStatus.effects.indexOf(val) != this.$root.wledStatus.state.seg[0].fx) {
        //update effect
        axios.post(this.$root.wledURL + "/json/state", {seg: [{fx: this.$root.wledStatus.effects.indexOf(val)}]});
      }
    }
  }
}
